import { render } from "./project_section_title_line_break.vue?vue&type=template&id=16552c08"
import script from "./project_section_title_line_break.vue?vue&type=script&lang=js"
export * from "./project_section_title_line_break.vue?vue&type=script&lang=js"

import "./project_section_title_line_break.vue?vue&type=style&index=0&id=16552c08&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__